import Task, { TaskEntity } from "core/models/Task";
import Agent from "core/services/api";
import { Result } from "core/models";

interface TaskResult {
    task: TaskEntity;
}

const getTask = async (
    accessToken: string,
    taskId: number,
): Promise<Result<Task, string>> => {
    const request = {
        id: taskId,
    };
    const headers = new Headers();
    headers.append("Authorization", accessToken);
    const result = await Agent.post<TaskResult>(
        "task/get/v1",
        request,
        headers,
        "site",
    );
    const { resultObject } = result;

    if (!resultObject) {
        return {
            value: undefined,
            error: "Unable get info for this task",
        };
    }
    return {
        value: new Task(resultObject.task),
        error: undefined,
    };
};
const getMultipleTasks = async (
    accessToken: string,
    taskIDs: number[],
): Promise<Result<Task[], string>> => {
    const request = {
        ids: taskIDs,
        excludeOtherFieldsIfProcessing: true,
    };
    const headers = new Headers();
    headers.append("Authorization", accessToken);
    const result = await Agent.post<TaskResult[]>(
        "task/getmultiple/v1",
        request,
        headers,
        "site",
    );
    const { resultObject } = result;

    if (!resultObject) {
        return {
            value: undefined,
            error: "Unable get the progess for these tasks",
        };
    }
    if (resultObject.length < 1) {
        return {
            value: [],
            error: undefined,
        };
    }
    const tasks: Task[] = resultObject.map((object) => new Task(object.task));

    return {
        value: tasks,
        error: undefined,
    };
};
const listTasks = async (
    accessToken: string,
    projectId: number,
    maxCount = 25,
): Promise<Result<Task[], string>> => {
    const request = {
        projectId,
        processingOnly: true,
        orderFields: ["insertionDate", false],
        maxCount,
    };
    const headers = new Headers();
    headers.append("Authorization", accessToken);
    const result = await Agent.post<TaskEntity[]>(
        "task/list/v1",
        request,
        headers,
        "site",
    );
    const { resultObject } = result;
    if (!resultObject) {
        return {
            value: undefined,
            error: "Unable get the progess for these tasks",
        };
    }
    if (resultObject.length < 1) {
        return {
            value: [],
            error: undefined,
        };
    }
    const tasks: Task[] = resultObject.map(
        (taskObject) => new Task(taskObject),
    );
    return {
        value: tasks,
        error: undefined,
    };
};

export { getTask, getMultipleTasks, listTasks };
